<template>
  <div :class="clazz" :style="style">
    <badgeWidget v-if="img" :img="img"></badgeWidget>
    <component
      v-for="element in config.elements"
      :key="element.id"
      :is="getComponentName(element)"
      :config="element"
    ></component>
  </div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import badgeWidget from "ireal-vue/widgets/BadgeWidget.vue";

export default {
  name: "div-component",
  mixins: [componentMixin],
  components: { badgeWidget },
  computed: {
    img() {
      return this.attributes.img;
    }
  }
};
</script>
<style scoped>
div {
  white-space: normal;
}
</style>
